import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";
import { managementAPI } from "../../../api/managementAPI/managementAPI.js";
import { guid } from "@progress/kendo-react-common";
import {
  GridEditContext,
  CommandCell,
  NameCell,
  rowRender,
  FORM_DATA_INDEX,
  DATA_ITEM_KEY,
} from "../../../context/GridEditContext.js";
import { PopUp } from "../../components/PopUp/PopUp.js";
import { filterBy } from "@progress/kendo-data-query";
import { RiDownloadCloud2Line } from "react-icons/ri";

const ADD = "add";
const initialSort = [
  {
    field: "row",
    dir: "asc",
  },
];

const initialDataState = {
  skip: 0,
  take: 12,
};

const voidRecord = [];

function ManagementRequestGridContainer({
  dataGrid,
  show,
  setShow,
  setActive,
  handleDownload,
  setDataGrid,
}) {
  const [filter, setFilter] = useState();
  const [page, setPage] = useState(initialDataState);
  const [values, setValues] = useState(voidRecord);
  const [sort, setSort] = useState(initialSort);
  const [editIndex, setEditIndex] = useState(undefined);

  const hideModal = () => {
    setShow(false);
  };

  const pageChange = (event) => {
    setPage(event.page);
  };

  const filterChange = (event) => {
    if (event.filter && event.filter.filters.length > 0) {
      setFilter(event.filter);
    } else {
      setFilter(null);
    }
  };

  const onRowAction = useCallback(
    async (options) => {
      const newDataState = [...values];
      const originData = [...dataGrid];
      let newDataindex = -1;
      let originDataindex = -1;
      setActive(true);
      switch (options.operation) {
        case "remove":
          newDataindex = options.rowIndex;
          originDataindex = dataGrid.findIndex(
            (product) => product.id === newDataState[options.rowIndex].id
          );
          managementAPI
            .deleteBlackList(newDataState[newDataindex])
            .then((res) => {
              if (!res.status == 200) {
                setShow({
                  status: true,
                  message:
                    "Si sente un errore quando si tenta di rimuovere i dati",
                });
              } else {
                var newDataGrid = dataGrid.filter(
                  (values, index) => index !== originDataindex
                );
                setDataGrid(newDataGrid);
              }
            })
            .finally(setActive(false));

          break;
        case "save":
          newDataindex =
            options.operation === "add"
              ? newDataState.length - 1
              : newDataState.findIndex(
                  (product) => product.id === options.dataItem.id
                );
          originDataindex =
            options.operation === "add"
              ? originData.length - 1
              : dataGrid.findIndex(
                  (product) => product.id === options.dataItem.id
                );
          if (options.dataItem.add) {
            managementAPI
              .addBlackList(options.dataItem)
              .then((res) => {
                if (!res.status == 200) {
                  setShow({
                    status: true,
                    message:
                      "Si è verificato un errore durante il tentativo di aggiungere i dati",
                  });
                } else {
                  newDataState[newDataindex].id = res.data.id;
                  newDataState[newDataindex].contactName = res.data.contactName;
                  newDataState[newDataindex].email = res.data.email;
                  newDataState[newDataindex].phoneNumber = res.data.phoneNumber;
                  newDataState[newDataindex].updateUtcDateTime =
                    res.data.updateUtcDateTime;
                  newDataState[newDataindex].add = false;

                  dataGrid[originDataindex].id = res.data.id;
                  dataGrid[originDataindex].contactName = res.data.contactName;
                  dataGrid[originDataindex].email = res.data.email;
                  dataGrid[originDataindex].phoneNumber = res.data.phoneNumber;
                  dataGrid[originDataindex].updateUtcDateTime =
                    res.data.updateUtcDateTime;
                  dataGrid[originDataindex].add = false;

                  setValues(newDataState);
                }
              })
              .finally(() => {
                setActive(false);
                setEditIndex(undefined);
              });
          } else {
            managementAPI
              .updateBlackList(options.dataItem)
              .then((res) => {
                if (!res.status == 200) {
                  setShow({
                    status: true,
                    message:
                      "Si è verificato un errore durante il tentativo di aggiornare i dati",
                  });
                  setShow(true);
                } else {
                  newDataState[newDataindex].contactName =
                    options.dataItem.contactName;
                  newDataState[newDataindex].email = options.dataItem.email;
                  newDataState[newDataindex].phoneNumber =
                    options.dataItem.phoneNumber;
                  newDataState[newDataindex].updateUtcDateTime =
                    res.data.updateUtcDateTime;

                  dataGrid[originDataindex].contactName = res.data.contactName;
                  dataGrid[originDataindex].email = res.data.email;
                  dataGrid[originDataindex].phoneNumber = res.data.phoneNumber;
                  dataGrid[originDataindex].updateUtcDateTime =
                    res.data.updateUtcDateTime;
                  setValues(newDataState);
                }
              })
              .finally(() => {
                setActive(false);
                setEditIndex(undefined);
              });
          }

          break;
        case "add":
          const id = guid();
          newDataState.unshift({
            [FORM_DATA_INDEX]: newDataState.length,
            [DATA_ITEM_KEY]: id,
            [ADD]: true,
          });

          dataGrid.unshift({
            [FORM_DATA_INDEX]: dataGrid.length,
            [DATA_ITEM_KEY]: id,
            [ADD]: true,
          });
          setEditIndex(newDataState.length - 1);
          setValues(newDataState);
          break;
        default: {
          const newDataState = values.filter((x) => !x.add);
          dataGrid = dataGrid.filter((x) => !x.add);
          setValues(newDataState);
        }
      }
      setActive(false);
    },
    [values]
  );

  const onAddClick = useCallback(() => {
    onRowAction({
      rowIndex: values.length,
      operation: "add",
    });
  }, [onRowAction, values]);

  useEffect(() => {
    if (dataGrid !== undefined) {
      let newData;
      if (filter && filter.filters.length > 0) {
        newData = filterBy(dataGrid, filter).map((item, idx) => ({
          ...item,
          [FORM_DATA_INDEX]: idx,
          [ADD]: false,
        }));
      } else {
        newData = dataGrid.map((item, idx) => ({
          ...item,
          [FORM_DATA_INDEX]: idx,
          [ADD]: false,
        }));
      }
      setValues(newData);
    }
  }, [dataGrid, filter]);

  return (
    <>
      <PopUp show={show.status} handleClose={hideModal}>
        <div
          className="row"
          style={{
            height: "30px",
            marginLeft: "0px",
            marginRight: "0px",
            backgroundColor: "#FDA443",
            borderRadius: "10px 10px 0px 0px",
          }}
        >
          {" "}
        </div>
        <p></p>
        <h2 className="row justify-content-md-center"> {show.message}</h2>
      </PopUp>
      <GridEditContext.Provider
        value={{ onRowAction, editIndex, setEditIndex }}
      >
        <Grid
          style={{
            height: "650px",
          }}
          data={orderBy(values, sort).slice(page.skip, page.take + page.skip)}
          skip={page.skip}
          take={page.take}
          total={values.length}
          pageable={true}
          onPageChange={pageChange}
          resizable={true}
          sortable={true}
          sort={sort}
          onSortChange={(e) => {
            setSort(e.sort);
          }}
          dataItemKey={DATA_ITEM_KEY}
          rowRender={rowRender}
          filterable={true}
          filter={filter}
          onFilterChange={filterChange}
          className="custom-pager"
        >
          <GridToolbar
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <button
              title="Add new"
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
              style={{
                backgroundColor: "#007bff",
                color: "#fff",
                border: "1px solid #007bff",
              }}
              onClick={onAddClick}
            >
              Add new
            </button>
            <div style={{ flexGrow: 1 }}></div>
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-cancel-command"
              style={{
                backgroundColor: "#007bff",
                color: "#fff",
                border: "1px solid #007bff",
              }}
              onClick={handleDownload}
            >
              <RiDownloadCloud2Line size={20} style={{ marginRight: "5px" }} />
              Download Excel
            </button>
          </GridToolbar>
          <Column
            field="contactName"
            editor="text"
            title="Name"
            width="auto"
            cell={NameCell}
          />
          <Column
            field="phoneNumber"
            title="Telefono"
            width="auto"
            cell={NameCell}
          />
          <Column field="email" title="Email" width="auto" cell={NameCell} />
          <Column
            field="updateUtcDateTime"
            title="Data aagg."
            width="auto"
            cell={(props) => {
              const date = new Date(props.dataItem["updateUtcDateTime"]);
              const formattedDate = date.toLocaleString("it-IT", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
              });
              return <td>{formattedDate}</td>;
            }}
          />
          <Column
            field="insertUser"
            title="Utente"
            width="auto"
            editable={true}
          />
          <Column title="Command" cell={CommandCell} />
        </Grid>
      </GridEditContext.Provider>
    </>
  );
}

export const ManagementRequestGrid = connect(
  null,
  null
)(ManagementRequestGridContainer);
